<div class="modal-template">
  <tp-icon
    *ngIf="showCloseIcon"
    class="modal-template__close-icon"
    name="icons/close"
    (click)="close()"
  ></tp-icon>

  <header *ngIf="header" class="modal-template__header">
    <div class="modal-template__title">{{ header }}</div>
  </header>

  <section class="modal-template__body">
    <ng-content></ng-content>
  </section>
</div>
